module.exports = __webpack_public_path__ + "img/base.064a5a35.svg";